module.exports = __webpack_public_path__ + "static/media/Storage-how-it-works-1.edfcf80a.jpg";